import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

// Suppress ResizeObserver loop errors (harmless in development)
const resizeObserverError = window.console.error;
window.console.error = (...args) => {
    if (
        typeof args[0] === 'string' &&
        args[0].includes('ResizeObserver loop')
    ) {
        return;
    }
    resizeObserverError(...args);
};

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
